module.exports = __webpack_public_path__ + "static/img/ys4.30ecfaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ys4.jpg
// module id = dHUP
// module chunks = 1